import calls from '@/backend/api-calls'

const state = () => ({
  projects: [],
  loading: true,
  firstLoad: true,
  pagination: {
    page: 1,
    pages: 1
  },
  filters: {
    defected_pieces: null
  }
})

// getters
const getters = {
}

// actions
const actions = {
  getProjects: ({commit}, parameters) => {
    commit("setLoading", true);
    
    return new Promise((resolve, reject) => {
      calls.projects.get(parameters)
        .then(resp => {
          commit("setLoading", false);
          commit("setFirstLoad", false);
          commit("setProjects", resp.data);
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  }
}

// mutations
const mutations = {
  setLoading (state, value) {
    state.loading = value;
  },
  setFirstLoad (state, value) {
    state.firstLoad = value;
  },
  setProjects (state, data) {
    state.pagination = data.pagination;
    state.projects = data.results;
  },
  changePage (state, page) {
    state.pagination.page = page;
  },
  setFilter (state, {field, value}) {
    state.filters[field] = value;
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}